import React from 'react';
import PropTypes from 'prop-types';

import GDPRHint from '../GDPRHint';

import {FormattedMessageWrappedInSpan} from '../../misc';
import Collapse from '@material-ui/core/Collapse';

// import { getMockImgUrl } from '../../../utils/dev';

function FaceRecognitionUpload(props) {

  const uploadPhotoChange = (e) => {
    props.onChange(e);
  }

  const acceptPrivacyPolicy = (e) => {
    props.onChangePrivacyPolicy(e);
  }

  return (
    <>
      <div className="face-recognition-upload-container">
        <div className="startnumber-search-label">
          <FormattedMessageWrappedInSpan
            id="FaceRecognitionUpload.searchLabel"
            defaultMessage="Take a selfie or upload a photo of you"
          />
        </div>
        <div className="face-recognition-file-upload">
          <div className="face-recognition-img">
            {props.imgSrc !== null && props.imgSrc !== undefined ? (
              <img src={props.imgSrc} />
            ) : (
              <span />
            )}
          </div>
          <input id={props.elementId} type="file" accept="image/*" onChange={uploadPhotoChange} />
          <div className="startnumber-search-sublabel">
            <FormattedMessageWrappedInSpan
              id="FaceRecognitionUpload.searchSubLabel"
              defaultMessage="The uploaded selfie will not be transmitted before you click 'Search with selfie' and will not be stored after your search request."
            />
          </div>
        </div>
        <Collapse in={props.imgSrc !== null && props.imgSrc !== undefined} timeout="auto">
          <GDPRHint className="mb-15 ml-15 mr-15" faceNote={true} onChange={acceptPrivacyPolicy}/>
        </Collapse>
      </div>
    </>
  );
}

FaceRecognitionUpload.defaultProps = {
  imgSrc: null,
  elementId: "faceRecoInput",
};

FaceRecognitionUpload.propTypes = {
  imgSrc: PropTypes.string,
  elementId: PropTypes.string,
  onChange: PropTypes.func,
  onChangePrivacyPolicy: PropTypes.func
};

export {FaceRecognitionUpload};

export default FaceRecognitionUpload;
